// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2T9XM","top":"styles_top__3yEmm"};